/* eslint-disable react/state-in-constructor */
import React, { Component } from 'react';

import { bool, func, shape, node } from 'prop-types';

import ClickAwayListener from '@mui/material/ClickAwayListener';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';

import s from './WithPopover.css';

export default class WithPopover extends Component {
  state = {
    arrowRef: null,
  };

  setArrowRef = nodeRef => this.setState({ arrowRef: nodeRef });

  render() {
    const { children, anchor, setAnchor, popover, arrowStyle, hideArrow } =
      this.props;
    const { arrowRef } = this.state;
    const popperStyle = { zIndex: 9999 };
    return (
      <>
        {children}

        <Popper
          className={s.arrowPopper}
          open={Boolean(anchor)}
          anchorEl={anchor}
          anchorReference="anchorEl"
          onClose={() => setAnchor(null)}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          popperOptions={{
            modifiers: {
              arrow: {
                enabled: Boolean(arrowRef),
                element: arrowRef,
              },
            },
          }}
          style={popperStyle}
        >
          <ClickAwayListener
            onClickAway={e => {
              e.preventDefault();
              e.stopPropagation();
              setAnchor(null);
            }}
          >
            <div>
              {!hideArrow && (
                <span
                  className={s.arrowArrow}
                  style={arrowStyle}
                  ref={this.setArrowRef}
                />
              )}
              <Paper className={s.paper}>{popover}</Paper>
            </div>
          </ClickAwayListener>
        </Popper>
      </>
    );
  }
}

WithPopover.propTypes = {
  children: node.isRequired,
  anchor: node.isRequired,
  setAnchor: func.isRequired,
  popover: node.isRequired,
  arrowStyle: shape({}).isRequired,
  hideArrow: bool.isRequired,
};
